import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  // Scroll effect for navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const testimonials = [
    {
      id: 1,
      name: 'Mehmet Yılmaz',
      company: 'Yılmaz İnşaat, Manisa',
      rating: 4.9,
      text: 'Has Makine ile çalışmak gerçekten keyifliydi. Ekskavatörümüzün komple revizyonunu çok kısa sürede ve profesyonelce tamamladılar. Hem hız hem kalite açısından kesinlikle tavsiye ediyorum.',
      avatar: 'https://public.readdy.ai/ai/img_res/8d24cef082edffd2603983f734b4fd55.jpg'
    },
    {
      id: 2,
      name: 'Ayşe Demir',
      company: 'Demir Hafriyat, Salihli',
      rating: 5.0,
      text: 'GES projemiz için arazi hazırlığı konusunda Has Makine ekibi ile çalıştık. Zamanında teslimat, kaliteli işçilik ve uygun fiyat. Kesinlikle güvenilir bir firma, teşekkür ederiz.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20female%20engineer%20wearing%20safety%20equipment%20in%20construction%20site%20with%20industrial%20background%20confident%20business%20portrait&width=80&height=80&seq=testimonial2&orientation=squarish'
    },
    {
      id: 3,
      name: 'Hasan Kaya',
      company: 'Kaya Taahhüt, İzmir',
      rating: 4.8,
      text: 'Yedek parça ihtiyacımız için Has Makine her zaman ilk tercihimiz. Orijinal parça garantisi ve hızlı tedarik sayesinde iş makinelerimiz hiç durmadan çalışıyor. Çok memnunuz.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20male%20contractor%20wearing%20hard%20hat%20and%20safety%20vest%20in%20industrial%20machinery%20workshop%20confident%20business%20portrait%20with%20warm%20lighting&width=80&height=80&seq=testimonial3&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#2C2C2C] shadow-lg' : 'bg-[#2C2C2C]/90'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=700,fit=crop,q=95/YKbNNwWEEXuvM5n5/has_makina-removebg-preview-AE0vvOWxwECVXlKL.png" 
                alt="Has Makine" 
                className="h-12"
              />
              <span className="text-white text-2xl font-bold tracking-wide">HAS MAKİNE</span>
            </div>

            {/* Menu Items */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#anasayfa" className="text-white text-base hover:text-[#FDB913] transition-colors cursor-pointer whitespace-nowrap">Ana Sayfa</a>
              <a href="#hizmetlerimiz" className="text-white text-base hover:text-[#FDB913] transition-colors cursor-pointer whitespace-nowrap">Hizmetlerimiz</a>
              <a href="#hakkimizda" className="text-white text-base hover:text-[#FDB913] transition-colors cursor-pointer whitespace-nowrap">Hakkımızda</a>
              <a href="#referanslar" className="text-white text-base hover:text-[#FDB913] transition-colors cursor-pointer whitespace-nowrap">Referanslar</a>
              <a href="#iletisim" className="text-white text-base hover:text-[#FDB913] transition-colors cursor-pointer whitespace-nowrap">İletişim</a>
            </div>

            {/* CTA Button - Removed */}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="anasayfa" className="relative min-h-screen flex items-center pt-20">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=massive%20yellow%20excavator%20and%20heavy%20construction%20machinery%20working%20on%20large%20industrial%20construction%20site%20with%20dirt%20and%20rocks%20dramatic%20angle%20showing%20power%20and%20scale%20of%20equipment%20under%20bright%20daylight%20professional%20industrial%20photography&width=1920&height=1080&seq=hero1&orientation=landscape" 
            alt="Heavy Machinery" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
          <div className="max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/95 border-2 border-[#FDB913] px-4 py-2 rounded-full mb-6">
              <i className="ri-award-line text-[#FDB913]"></i>
              <span className="text-sm font-semibold text-[#2C2C2C]">SALİHLİ'NİN LİDER FİRMASI</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
              İş Makinelerinde Güven ve Profesyonel Çözümler
            </h1>

            {/* Subheading */}
            <p className="text-xl text-gray-200 mb-8 leading-relaxed font-light">
              Bakım, onarım, yedek parça ve hafriyat hizmetlerinde Salihli'nin lider firması
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <a href="#hizmetlerimiz" className="bg-[#FDB913] text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#FDB913]/90 transition-all cursor-pointer whitespace-nowrap">
                HİZMETLERİMİZ
              </a>
              <a href="#iletisim" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap">
                BİZE ULAŞIN
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="hizmetlerimiz" className="py-20 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">Hizmetlerimiz</h2>
            <p className="text-xl text-gray-600">Profesyonel ekibimizle size en iyi hizmeti sunuyoruz</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Service 1 - Technical Service */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-2 cursor-pointer">
              <div className="h-64 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=skilled%20mechanic%20repairing%20heavy%20construction%20machinery%20engine%20in%20professional%20industrial%20workshop%20with%20tools%20and%20equipment%20detailed%20maintenance%20work%20on%20yellow%20excavator%20hydraulic%20system%20technical%20service%20scene%20with%20clean%20organized%20workspace&width=600&height=400&seq=service1tech&orientation=landscape" 
                  alt="Teknik Servis" 
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="inline-block bg-gradient-to-r from-[#FDB913] to-[#2C2C2C] text-white px-4 py-1 rounded-full text-xs font-bold mb-4">
                  BAKIM & ONARIM
                </div>
                <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Ağır İş Makineleri Servisi</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Komple revizyon, torna, kaynak ve bakım-onarım hizmetleri. Uzman ekibimizle tüm marka iş makinelerinize profesyonel servis desteği sağlıyoruz.
                </p>
                <div className="flex justify-end">
                  <i className="ri-arrow-right-line text-[#FDB913] text-2xl"></i>
                </div>
              </div>
            </div>

            {/* Service 2 - Excavation */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-2 cursor-pointer">
              <div className="h-64 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=large%20yellow%20excavator%20preparing%20land%20for%20solar%20power%20plant%20construction%20site%20clearing%20forest%20area%20for%20renewable%20energy%20project%20with%20dirt%20and%20earth%20moving%20equipment%20working%20on%20green%20energy%20infrastructure%20development%20under%20clear%20blue%20sky&width=600&height=400&seq=service2excavation&orientation=landscape" 
                  alt="Hafriyat ve Proje" 
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="inline-block bg-gradient-to-r from-[#FDB913] to-[#2C2C2C] text-white px-4 py-1 rounded-full text-xs font-bold mb-4">
                  HAFRİYAT & PROJE
                </div>
                <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Hafriyat ve Taahhüt İşleri</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Orman arazisi hazırlığı, GES (Güneş Enerjisi Santrali) altyapı projeleri ve yol yapım işleri. Büyük ölçekli projelerde deneyimli kadromuzla yanınızdayız.
                </p>
                <div className="flex justify-end">
                  <i className="ri-arrow-right-line text-[#FDB913] text-2xl"></i>
                </div>
              </div>
            </div>

            {/* Service 3 - Trading */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-2 cursor-pointer">
              <div className="h-64 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20construction%20machinery%20sales%20showroom%20with%20multiple%20yellow%20excavators%20loaders%20and%20heavy%20equipment%20displayed%20in%20organized%20industrial%20facility%20business%20handshake%20between%20dealer%20and%20customer%20with%20construction%20machines%20in%20background%20trading%20and%20sales%20environment&width=600&height=400&seq=service3trading&orientation=landscape" 
                  alt="Makine Alım Satım" 
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="inline-block bg-gradient-to-r from-[#FDB913] to-[#2C2C2C] text-white px-4 py-1 rounded-full text-xs font-bold mb-4">
                  ALIM & SATIM
                </div>
                <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Makine Alım Satım</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Her türlü iş makinesi alım-satım danışmanlığı. Ekskavatör, loder, greyder ve tüm inşaat makineleri için güvenilir alım satım hizmeti sunuyoruz.
                </p>
                <div className="flex justify-end">
                  <i className="ri-arrow-right-line text-[#FDB913] text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="hakkimizda" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            {/* Left Visual */}
            <div className="md:col-span-2 relative">
              <div className="absolute -top-4 -left-4 bg-white border-2 border-[#FDB913] px-4 py-2 rounded-full z-10">
                <span className="text-sm font-bold text-[#2C2C2C]">15 YIL TECRÜBE</span>
              </div>
              <div className="rounded-3xl overflow-hidden border-4 border-[#FDB913]/30">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20turkish%20mechanics%20team%20working%20together%20on%20heavy%20construction%20machinery%20in%20modern%20industrial%20workshop%20wearing%20safety%20equipment%20and%20uniforms%20collaborative%20teamwork%20scene%20with%20tools%20and%20equipment&width=600&height=700&seq=about1&orientation=portrait" 
                  alt="Has Makine Ekibi" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="md:col-span-3">
              <h2 className="text-5xl font-bold mb-6 leading-tight">
                <span className="text-[#2C2C2C]">Profesyonel Ekip</span><br />
                <span className="text-[#FDB913]">Kaliteli Hizmet</span><br />
                <span className="text-[#2C2C2C]">Zamanında Teslimat</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                HAS MAKİNE 2007 yılında Hasan KIYMAZ tarafından Manisa'nın Salihli ilçesinde Ağır İş Makineleri üzerinde torna, kaynak, tamir, bakım atölyesi ve hafriyat üretimleri amacıyla kurulmuştur.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Ağır iş makinelerinin (dozer, kepçe, ekskavatör, greyder) bakım, torna, kaynak, tamir bıçakları ve komple bakım işlemlerini profesyonel bir şekilde gerçekleştiriyoruz. Bunun yanı sıra dozerlere ön tarak ve hidroliklerine piston imalatımız vardır. Her türlü iş makinelerinin alım-satım işlemlerini gerçekleştiriyoruz.
              </p>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#FDB913] mb-2">15+</div>
                  <div className="text-sm text-gray-600">Yıl Tecrübe</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#FDB913] mb-2">500+</div>
                  <div className="text-sm text-gray-600">Tamamlanan Proje</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#FDB913] mb-2">100%</div>
                  <div className="text-sm text-gray-600">Müşteri Memnuniyeti</div>
                </div>
              </div>

              <button className="bg-[#2C2C2C] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#2C2C2C]/90 transition-all whitespace-nowrap">
                DETAYLI BİLGİ
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="referanslar" className="py-20 bg-[#F5F5F5]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Müşterilerimiz Ne Diyor?
            </h2>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-12 relative">
            {/* Rating Badge */}
            <div className="absolute top-8 left-8 bg-[#2C2C2C] text-[#FDB913] px-4 py-2 rounded-full flex items-center gap-2">
              <i className="ri-star-fill"></i>
              <span className="font-bold">{testimonials[currentTestimonial].rating}</span>
            </div>

            {/* Testimonial Content */}
            <div className="mt-12">
              <p className="text-2xl text-gray-700 mb-8 leading-relaxed italic" style={{ fontFamily: 'Georgia, serif' }}>
                "{testimonials[currentTestimonial].text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <img 
                    src={testimonials[currentTestimonial].avatar} 
                    alt={testimonials[currentTestimonial].name}
                    className="w-16 h-16 rounded-full object-cover object-top"
                  />
                  <div>
                    <div className="font-bold text-lg text-[#2C2C2C]">{testimonials[currentTestimonial].name}</div>
                    <div className="text-sm text-gray-500">{testimonials[currentTestimonial].company}</div>
                  </div>
                </div>

                {/* Navigation Buttons */}
                <div className="flex gap-3">
                  <button 
                    onClick={prevTestimonial}
                    className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-lg hover:border-[#FDB913] hover:text-[#FDB913] transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-left-line text-xl"></i>
                  </button>
                  <button 
                    onClick={nextTestimonial}
                    className="w-12 h-12 flex items-center justify-center bg-[#2C2C2C] text-[#FDB913] rounded-lg hover:bg-[#2C2C2C]/90 transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-xl"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Modified */}
      <section className="py-20 bg-[#FFF8E1]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="rounded-3xl overflow-hidden mb-8">
            <img 
              src="https://readdy.ai/api/search-image?query=close%20up%20detail%20shot%20of%20yellow%20heavy%20construction%20machinery%20hydraulic%20arm%20and%20equipment%20with%20industrial%20metal%20textures%20professional%20equipment%20photography%20with%20shallow%20depth%20of%20field&width=1200&height=400&seq=cta1&orientation=landscape" 
              alt="Machinery Detail" 
              className="w-full h-64 object-cover object-top"
            />
          </div>

          <div className="text-center">
            <h2 className="text-5xl font-light text-[#2C2C2C] mb-8 leading-relaxed">
              Projeniz için <span className="font-bold italic">profesyonel çözüm</span> mü arıyorsunuz?
            </h2>
            <a href="#iletisim" className="inline-block bg-[#2C2C2C] text-white px-12 py-5 rounded-full text-lg font-bold hover:bg-[#2C2C2C]/90 transition-all cursor-pointer whitespace-nowrap">
              BİZE ULAŞIN
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="iletisim" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">İletişim</h2>
            <p className="text-xl text-gray-600">Bize ulaşın, size yardımcı olalım</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <div className="space-y-8">
                {/* Address */}
                <div className="flex gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FDB913] rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-[#2C2C2C]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#2C2C2C] mb-2">Adres</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Atatürk Mah. Ata Sanayi Sitesi<br />
                      549 Sok. No:117<br />
                      Salihli / MANİSA
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FDB913] rounded-xl flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-[#2C2C2C]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#2C2C2C] mb-2">Telefon</h3>
                    <p className="text-gray-600">
                      <a href="tel:+905386582679" className="hover:text-[#FDB913] transition-colors">+90 538 658 26 79</a><br />
                      <a href="tel:02367141718" className="hover:text-[#FDB913] transition-colors">0 236 714 17 18</a>
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FDB913] rounded-xl flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-[#2C2C2C]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#2C2C2C] mb-2">E-posta</h3>
                    <p className="text-gray-600">
                      <a href="mailto:hasmakinasalihli@hotmail.com" className="hover:text-[#FDB913] transition-colors">
                        hasmakinasalihli@hotmail.com
                      </a>
                    </p>
                  </div>
                </div>

                {/* Working Hours */}
                <div className="flex gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FDB913] rounded-xl flex-shrink-0">
                    <i className="ri-time-line text-2xl text-[#2C2C2C]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#2C2C2C] mb-2">Çalışma Saatleri</h3>
                    <p className="text-gray-600">
                      Pazartesi - Cumartesi: 08:00 - 18:00<br />
                      Pazar: Kapalı
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden shadow-lg h-[500px]">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3089.123456789!2d28.13970000000001!3d38.48250000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b97e6b123456789%3A0x123456789abcdef0!2sAtat%C3%BCrk%20Mah.%20Ata%20Sanayi%20Sitesi%20549%20Sok.%20No%3A117%2C%2045300%20Salihli%2FManisa%2C%20T%C3%BCrkiye!5e0!3m2!1str!2str!4v1640000000000!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Has Makine Konum"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] rounded-3xl mx-5 mb-5 mt-20">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            {/* Brand Column */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FDB913] rounded-lg">
                  <i className="ri-excavator-line text-2xl text-[#2C2C2C]"></i>
                </div>
                <span className="text-white text-2xl font-bold">HAS MAKİNE</span>
              </div>
              <div className="w-20 h-1 bg-[#FDB913] mb-4"></div>
              <p className="text-gray-400 text-sm leading-relaxed">
                İş makinelerinde güven ve profesyonel çözümler
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-white text-lg font-bold mb-4">Hızlı Erişim</h3>
              <ul className="space-y-3">
                <li><a href="#anasayfa" className="text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">Ana Sayfa</a></li>
                <li><a href="#hizmetlerimiz" className="text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">Hizmetler</a></li>
                <li><a href="#hakkimizda" className="text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">Hakkımızda</a></li>
                <li><a href="#referanslar" className="text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">Referanslar</a></li>
                <li><a href="#iletisim" className="text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">İletişim</a></li>
              </ul>
            </div>

            {/* Social Media */}
            <div>
              <h3 className="text-white text-lg font-bold mb-4">Bizi Takip Edin</h3>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="flex items-center gap-3 text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-[#FDB913] text-xl w-5 h-5 flex items-center justify-center"></i>
                    <span>Instagram</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-3 text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">
                    <i className="ri-facebook-line text-[#FDB913] text-xl w-5 h-5 flex items-center justify-center"></i>
                    <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-3 text-gray-400 hover:text-[#FDB913] transition-colors cursor-pointer">
                    <i className="ri-linkedin-line text-[#FDB913] text-xl w-5 h-5 flex items-center justify-center"></i>
                    <span>LinkedIn</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h3 className="text-white text-lg font-bold mb-4">Bülten</h3>
              <p className="text-gray-400 text-sm mb-4">
                Kampanya ve fırsatlardan haberdar olun
              </p>
              <div className="flex gap-2">
                <input 
                  type="email" 
                  placeholder="E-posta adresiniz"
                  className="flex-1 bg-[#2C2C2C] text-white px-4 py-3 rounded-lg text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FDB913]"
                />
                <button className="w-12 h-12 flex items-center justify-center bg-white rounded-full hover:bg-gray-100 transition-all cursor-pointer flex-shrink-0">
                  <i className="ri-arrow-right-line text-[#FDB913] text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-center items-center gap-4">
              <p className="text-gray-500 text-sm">
                © 2024 Has Makine. Tüm hakları saklıdır.
              </p>
            </div>
          </div>

          {/* Background Decoration */}
          <div className="absolute bottom-0 right-0 text-[#2C2C2C] text-9xl font-bold opacity-10 pointer-events-none select-none">
            HAS MAKİNE
          </div>
        </div>
      </footer>
    </div>
  );
}
